import { createFileRoute, redirect } from "@tanstack/react-router";
import { TariffsClient, type TariffsTab } from "@/features/billing/TariffsClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";
import { mayReadTariffs } from "@/features/billing/access";

// Commercie → Tarieven (docs/tms-facturatie.md §24): per customer its price agreement, the changes waiting for
// approval, the tariffs and the English texts. Billing reads; price_agreements_write changes an agreement and raises
// prices, price_agreements_approve approves a change (§24.10).
export const Route = createFileRoute("/_shell/billing/tariffs/")({
  beforeLoad: ({ context }) => {
    if (!mayReadTariffs(context.session)) throw redirect({ to: firstAllowedRoute(context.session) });
  },
  validateSearch: (search: Record<string, unknown>): { tab?: TariffsTab; all?: boolean } => ({
    tab: search.tab === "tariffs" || search.tab === "texts" || search.tab === "changes" || search.tab === "surcharges" ? search.tab : undefined,
    all: search.all === true || search.all === "true" ? true : undefined,
  }),
  component: TariffsScreen,
});

function TariffsScreen() {
  const { session } = Route.useRouteContext();
  const { tab, all } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Tariffs">
      <TariffsClient
        tab={tab ?? "customers"}
        all={all ?? false}
        userId={session.userId}
        canWrite={session.roles.includes("admin") || hasModule(session, "billing_write")}
        canChange={session.roles.includes("admin") || hasModule(session, "price_agreements_write")}
        canApprove={session.roles.includes("admin") || hasModule(session, "price_agreements_approve")}
        onTab={(next) => navigate({ search: (s) => ({ ...s, tab: next === "customers" ? undefined : next }) })}
        onAll={(next) => navigate({ search: (s) => ({ ...s, all: next || undefined }) })}
      />
    </div>
  );
}
